import React from "react";
import Card from "./Card.js";

const QuoteCard = ({ quote, label }) => (
  <Card className="provider-beta__quote-card" as="blockquote">
    {label ? <p className="provider-beta__quote-label">{label}</p> : null}
    <p className="provider-beta__quote-text">{quote}</p>
  </Card>
);

export default QuoteCard;
